import { useState } from "react";
import Required from "../../../common-components/Required";
import { useDispatch, useSelector } from "react-redux";
import {
  fileDelete,
  fileUpload,
  previewImage,
  progressPercentage,
  setSelectedFile,
} from "../../../../slices/FileUploadSlice";
import FileUploader from "../../../common-components/FileUploader";
import CloseButton from "../../../custom-components/CloseButton";
import CancelButton from "../../../custom-components/CancelButton";
import BlackButton from "../../../custom-components/BlackButton";
import ImagePreviewWithFilename from "../../../common-components/ImagePreviewWithFilename";
import ErrorMessageComponent from "../../../common-components/ErrorMessageComponent";
import useFileValidation from "../../../../util/useFileValidation";
import ErrorAlert from "../../../common-components/ErrorAlert";
import ErrorMessages from "../../../../util/ErrorMessages";
import { NewGetToKnowACValidations } from "../../../../util/Validations";
import {
  setPreThumbnailId,
  setPrevThumbnailDetails,
} from "../../../../slices/GetToKnowACSlice";
import { GetToKnowAC } from "../../../../util/Strings";

function AddGetToKnowACForm({ show, onClickNext, data }) {
  const dispatch = useDispatch();
  const fileUploadId = useSelector((state) => state.upload.id);
  const [state, setState] = useState({
    description: data && data.description ? data.description : "",
    photoId: data && data.photoId ? data.photoId : null,
  });
  const [prevFileData, setPreFileData] = useState({
    photoUrl: data && data.photoUrl ? data.photoUrl : null,
    fileName: data && data.fileName ? data.fileName : "file",
  });
  const [prevFileId, setPrevFileId] = useState(
    data && data.photoId ? data.photoId : null
  );
  const prevImageId = useSelector((state) => state.ac.prevThumbnailId);
  const [validation, setValidation] = useState({});
  const { errorSingleMessage, setErrorSingleMessage, validateFile } =
    useFileValidation();
  const [imageDeleteList, setImageDeleteList] = useState([]);

  function handleChange(e) {
    const value = e.target.value;
    setState({
      ...state,
      [e.target.name]: value,
    });
  }

  const resetPrevFileData = useSelector(
    (state) => state.ac.prevThumbnailDetails
  );

  const errorMessageCode = useSelector((state) => state.upload.errorCode);
  function handleImageCancel() {
    setState({
      ...state,
      ["photoId"]: null,
    });
    prevFileData.photoUrl = null;
    setImageDeleteList([...imageDeleteList, prevFileId]);
  }
  function handleCloseErrorAlert() {
    setPreFileData(resetPrevFileData);
    handleState();
    dispatch(setSelectedFile(null));
    setImageDeleteList([]);
    onClickNext();
  }

  const [photoUrl, setPhotoUrl] = useState(null);

  function resetImage() {
    dispatch(progressPercentage(0));
    dispatch(setSelectedFile(null));
    dispatch(previewImage(null));
  }

  function handleState() {
    setState({ ...state, ["photoId"]: data && data.photoId });
  }

  const checkValidation = () => {
    const { errors, isValid } = NewGetToKnowACValidations(state);
    setValidation(errors);
    return isValid;
  };

  function handleCreateButton() {
    if (checkValidation()) {
      if (state.description) {
        resetImage();
        if (data) {
          const newData = {
            description: state.description,
            photoId: state.photoId,
          };
          imageDeleteList &&
            imageDeleteList.map((image) => {
              dispatch(fileDelete({ id: image }));
            });
          setPhotoUrl(null);
          onClickNext(newData);

          if (state.photoId !== prevImageId && prevImageId !== "") {
            const id = { id: prevImageId, isVideo: false };
            dispatch(fileDelete(id));
            dispatch(setPreThumbnailId(""));
          }
          setPreFileData({
            photoUrl: data && data.photoUrl ? data.photoUrl : null,
            fileName: data && data.fileName ? data.fileName : null,
          });
          setErrorSingleMessage("");
        } else {
          setState({});
          setPhotoUrl(null);
          setImageDeleteList([]);
          onClickNext(state);
        }
      } else {
        onClickNext();
      }
    }
  }

  if (!show) {
    return null;
  }

  const handleFileSelect = function (event) {
    const files = event.target.files;
    postFileData(files);
  };

  const handleDrag = function (event) {
    event.preventDefault();
  };

  const handleDrop = function (event) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    postFileData(files);
  };

  function postFileData(files) {
    const valid = validateFile(files);
    if (valid) {
      const file = files[0];
      if (prevFileData) {
        dispatch(setPreThumbnailId(prevFileId));
        setPrevFileId(prevFileId);
        dispatch(setPrevThumbnailDetails(prevFileData));
        setPreFileData({ photoUrl: null, fileName: null });
      }
      if (file) {
        dispatch(setSelectedFile(file));
        dispatch(fileUpload(file))
          .unwrap()
          .then((res) => {
            setPhotoUrl(res[0]._id);
            setState({ ...state, ["photoId"]: res[0]._id });
            setPrevFileId(res[0]._id);
          });
      }
    }
  }
  if (errorMessageCode) {
    return (
      <ErrorAlert
        show={errorMessageCode}
        onClickHandle={handleCloseErrorAlert}
        title="Error"
        subTitle={ErrorMessages(errorMessageCode)}
      />
    );
  }
  return (
    <div className="modal">
      <div className="form-scroll">
        <div className="form-flex">
          <div
            className="user-form-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="form-header">
              <div className="header">
                {data ? "Update AC Visit Partner" : "Add AC Visit Partner"}
              </div>
              <CloseButton
                onClickhandle={() => {
                  resetImage();
                  if (data === null) {
                    setState({});
                    setValidation({});
                  }
                  setPreFileData({
                    photoUrl: data && data.photoUrl ? data.photoUrl : null,
                    fileName: data && data.fileName ? data.fileName : "file",
                  });
                  setImageDeleteList([]);
                  setErrorSingleMessage("");
                  onClickNext();
                }}
              />
            </div>

            <div className="form-container">
              <div className="form-label-input">
                <label className="form-label">
                  {GetToKnowAC.description}
                  <Required />
                </label>
                <div className="user-form-input-container">
                  <textarea
                    className="form-input"
                    type="text"
                    value={state.description}
                    name="description"
                    onChange={(e) => handleChange(e)}
                    placeholder="Input"
                    rows={3}
                  ></textarea>
                </div>
                <ErrorMessageComponent message={validation.description} />
              </div>

              <FileUploader
                previewShape="rectangle"
                headerName="Photo"
                handleDragOver={handleDrag}
                handleDrop={handleDrop}
                handleFileSelect={handleFileSelect}
                setPreFileData={setPreFileData}
                handleState={handleState}
                type="ac"
              />
              {errorSingleMessage !== "" && (
                <p className="error image-error">{errorSingleMessage}</p>
              )}
              {prevFileData &&
              prevFileData.photoUrl &&
              data &&
              data.photoUrl &&
              data.fileName ? (
                <ImagePreviewWithFilename
                  photoUrl={data.photoUrl}
                  fileName={data.fileName}
                  previewShape="rectangle"
                  handleCancel={handleImageCancel}
                />
              ) : null}

              <div className="footer-button-container">
                <CancelButton
                  onClickhandle={() => {
                    resetImage();
                    if (data === null) {
                      setState({});
                      setValidation({});
                    }
                    setPreFileData({
                      photoUrl: data && data.photoUrl ? data.photoUrl : null,
                      fileName: data && data.fileName ? data.fileName : "file",
                    });
                    setImageDeleteList([]);
                    setErrorSingleMessage("");
                    onClickNext();
                  }}
                >
                  {GetToKnowAC.cancel}
                </CancelButton>
                <BlackButton onClickhandle={() => handleCreateButton()}>
                  {data ? GetToKnowAC.update : GetToKnowAC.add}
                </BlackButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddGetToKnowACForm;
